import { ILineType } from "@/domain/entities/lineInfo";
import { LineType } from "@/domain/entities/lineInfo/lineType";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import { HttpLineType, ILineTypeParser } from "../lineInfoRepository.types";

@injectable()
export class LineTypeParser implements ILineTypeParser {
  constructor() {}

  toDomain(data: HttpLineType): Result<ILineType, ParseError> {
    try {
      const lineTypeData: ILineType = {
        lineTypeCode: data.lineTypeCode,
        lineTypeName: data.lineTypeName,
        displayOrder: data.displayOrder,
      };
      const lineType = new LineType(lineTypeData);
      return ok(lineType);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
